import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Modal, DatePicker, Spin } from 'antd';

import {
    selectorDataActual,
    selectorPeticioDataActualEnCurs
} from '../../selectors/selector_data_actual';

import { selectorPeticioDonarDeBaixaEstacioEnCurs } from '../../selectors/selector_estacio_peticio_donar_de_baixa_estacio_en_curs';
import selectorEstacioFormulariId from '../../selectors/selector_estacio_formulari_id';

import {
    MASCARA_DDMMYYYY,
    MASCARA_YYYYMMDD,
    esDataFiPeriodeDeshabilitat,
    convertirTextAMomentUTC,
} from '../../commons/gestioDates';

import {
    obtenirDataHoraActualUTC,
    estacioDonarDeBaixaEstacio
} from '../../actions';

class EstacioDetallDonarDeBaixaEstacio extends Component {

    constructor(props) {
        super(props);
        this.state = { modalVisible: false, dataBaixaSeleccionada: null };
        this.modificarDataDeBaixa = this.modificarDataDeBaixa.bind(this);
        this.mostrarModal = this.mostrarModal.bind(this);
        this.amagarModal = this.amagarModal.bind(this);
        this.onClickOk = this.onClickOk.bind(this);
    }

    componentDidMount() {
        this.props.obtenirDataHoraActualUTC();
    }

    componentWillReceiveProps(nextProps) {
        const { dataActualText } = nextProps;
        const dataActual = (dataActualText) ? convertirTextAMomentUTC(dataActualText) : null;

        if (dataActual && !this.state.dataBaixaSeleccionada) {
            this.setState({...this.state, dataBaixaSeleccionada: dataActual});
        }
    }

    modificarDataDeBaixa(dataBaixaSeleccionada) {
        if (dataBaixaSeleccionada) {
            this.setState({...this.state, dataBaixaSeleccionada});
        }
    }

    onClickOk() {
        const { idEstacio, nomEstacio, estacioDonarDeBaixaEstacio, router } = this.props;
        const { dataBaixaSeleccionada } = this.state;
        estacioDonarDeBaixaEstacio(idEstacio, nomEstacio, dataBaixaSeleccionada, router);
    }

    mostrarModal() {
        this.setState({...this.state, modalVisible: true});
    }

    amagarModal() {
        this.setState({...this.state, modalVisible: false});
    }

    render() {

        const { dataAltaEstacioText, dataActualText, peticioDataActualEnCurs, peticioDonarDeBaixaEstacioEnCurs } = this.props;
        const { modalVisible, dataBaixaSeleccionada } = this.state;

        const dataAltaEstacio = convertirTextAMomentUTC(dataAltaEstacioText, MASCARA_YYYYMMDD);
        const dataAltaEstacioTextFormatPerMostrarUsuari = dataAltaEstacio.format(MASCARA_DDMMYYYY);
        const dataActual = (dataActualText) ? convertirTextAMomentUTC(dataActualText) : null;
        const noEsPossibleDonarDeBaixaEstacio = (!dataActual || peticioDataActualEnCurs || peticioDonarDeBaixaEstacioEnCurs);

        return (
            <div>
                <Button size='large' type="primary" onClick={this.mostrarModal}>
                    Donar de baixa
                </Button>
                <Modal
                    visible={modalVisible}
                    title="Donar de baixa una estació"
                    closable={false}
                    footer={[
                        <Button key="ok" type="primary" disabled={noEsPossibleDonarDeBaixaEstacio} onClick={this.onClickOk}>OK</Button>,
                        <Button key="cancel" disabled={noEsPossibleDonarDeBaixaEstacio} onClick={this.amagarModal}>Cancel·lar</Button>,
                    ]}
                >
                    <Spin spinning={noEsPossibleDonarDeBaixaEstacio}>
                        <div className='estacio-detall-donar-de-baixa-estacio'>
                            <span>Data d'alta:</span>
                            <span>{dataAltaEstacioTextFormatPerMostrarUsuari}</span>
                            <span>Data de baixa:</span>
                            <DatePicker
                                allowClear={false}
                                value={dataBaixaSeleccionada}
                                format={MASCARA_DDMMYYYY}
                                onChange={this.modificarDataDeBaixa}
                                disabledDate={dataCalendari => esDataFiPeriodeDeshabilitat(dataCalendari, dataActual, dataAltaEstacio, 'days')}
                            />
                        </div>
                    </Spin>
                </Modal>
            </div>
        );
    }
}

EstacioDetallDonarDeBaixaEstacio.propTypes = {
    idEstacio: PropTypes.number.isRequired,
    nomEstacio: PropTypes.string.isRequired,
    dataAltaEstacioText: PropTypes.string.isRequired,
    dataActualText: PropTypes.string,
    peticioDataActualEnCurs: PropTypes.bool,
    peticioDonarDeBaixaEstacioEnCurs: PropTypes.bool,
    obtenirDataHoraActualUTC: PropTypes.func,
    estacioDonarDeBaixaEstacio: PropTypes.func,
    router: PropTypes.object
};

const mapStateToProps = (state) => {
    return {
        idEstacio: selectorEstacioFormulariId(state),
        dataActualText: selectorDataActual(state),
        peticioDataActualEnCurs: selectorPeticioDataActualEnCurs(state),
        peticioDonarDeBaixaEstacioEnCurs: selectorPeticioDonarDeBaixaEstacioEnCurs(state)
    };
};

export default connect(mapStateToProps, {obtenirDataHoraActualUTC, estacioDonarDeBaixaEstacio})(EstacioDetallDonarDeBaixaEstacio);



// WEBPACK FOOTER //
// ./src/components/estacio/estacioDetallDonarDeBaixaEstacio.js